// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { colors } from "@mui/material";
import { createTheme } from "@mui/material";
import shadows from "./shadows";
import typography from "./typography";

const theme = createTheme({
  palette: {
    background: {
      default: "#fff",
      paper: colors.common.white,
    },
    primary: {
      contrastText: "#ffffff",
      main: "#212a32",
      light: "#465867",
    },
    secondary: {
      contrastText: "#fff",
      main: "#ff7300",
    },
    text: {
      primary: "#172b4d",
      secondary: "#6b778c",
    },
    success: {
      contrastText: "#ffffff",
      main: "#05c46b",
    },
    disabled: {
      main: "rgba(0, 0, 0, 0.30)"
    }, 
    colors: {
      delete: "#F37878",
      white: "#FFF"
    },
    status: {
      completed: "#76BA99",
      expired: "#F37878"
    }
  },
  transitions: {
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      // most basic recommended timing
      standard: 300,
      // this is to be used in complex animations
      complex: 375,
      // recommended when something is entering screen
      enteringScreen: 225,
      // recommended when something is leaving screen
      leavingScreen: 195,
    },
    easing: {
      // This is the most common easing curve.
      easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
      // Objects enter the screen at full velocity from off-screen and
      // slowly decelerate to a resting point.
      easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
      // Objects leave the screen at full velocity. They do not decelerate when off-screen.
      easeIn: "cubic-bezier(0.4, 0, 1, 1)",
      // The sharp curve is used by objects that may return to the screen at any time.
      sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
    },
  },
  shadows,
  typography,
  components: {
    MuiCollapse: {
      styleOverrides: {
        wrapperInner: {
          width: "100%",
        },
      },
    },
  },
});

export default theme;
